
















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IOutboundPicture from '@/store/models/IOutboundPicture';
import IBlob from '@/store/models/IBlob';
import IOutbound from '@/store/models/IOutbound';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
        vueDropzone: vue2Dropzone
    }
})
export default class OutboundPicture extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    OutboundPictures !: IOutboundPicture[];
    @Prop({ type: Array, required: true })
    OutboundPicturesCompanyDestination !: IOutboundPicture[];
    @Prop({ type: Array, required: true })
    OutboundPicturesCompanySource !: IOutboundPicture[];
    @Prop()
    CompanySourceName !: String;
    @Prop()
    CompanyDestinationName !: String;
    @Prop({ type: Array, required: true })
    BlobsSource !: IBlob[];
    @Prop({ type: Array, required: true })
    BlobsDestination !: IBlob[];
    @Prop()
    SelectedOutbound !: IOutbound;

    currFiles: any[] = [];
    files: any[] = [];
    selectedPictureSourceCompany: any[] = [];
    selectedPictureDestinationCompany: any[] = [];
    imageurl: string = "";
    blobUrlselected: string= "";
    dropzoneOptions: any = {
        url: 'http://localhost',
        thumbnailWidth: 150,
        maxFilesize: 25,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
        maxFiles: 10,
        previewsContainer: false
    }
    overlay: boolean = false;

    deleteOutboundPicture(item: IOutboundPicture) {
        this.$emit("deleteOutboundPicture", item);
    }

    remove(index: number) {
        this.files.splice(index, 1);
    }

    appendLocation(file: any) {
        this.overlay = true;
        this.files.push(file);
        this.overlay = false;
    }

    removeFile(file: any, xhr: any, formData: FormData) {
        let index = this.files.findIndex(f => f.name === file.name);
        if (index !== -1) {
            this.remove(index);
        }
    }

    onMaxFilesReached(files: any[]) {
        this.$emit("showMessageWarning", "A maximum of 10 files may be uploaded.");
        if (files.length > 10) {
            files.slice(10).forEach((file) => {
                this.remove(file);
            });
        }
    }

    get FilteredBlobsSource() : IBlob[] {
        return this.BlobsSource.filter(b => b.inboundId === this.SelectedOutbound.id);
    }

    get FilteredBlobsDestination() : IBlob[] {
        return this.BlobsDestination.filter(b => b.inboundId === this.SelectedOutbound.id);
    }

    uploadFiles() {
        if (!this.files) {
            this.$emit("showMessageWarning", "Please select a picture");
        }
        
        let formDatas : FormData = this.getFormData();
        this.$emit('uploadOutboundPicture', formDatas);
        this.currFiles = [];
        const dropzoneComponent = this.$refs.myVueDropzone as any;
        if (dropzoneComponent && typeof dropzoneComponent.removeAllFiles === 'function') {
            dropzoneComponent.removeAllFiles();
        }
        this.files = [];
    }

    getFormData () : FormData {
        let formData = new FormData();
        for (let file of this.files) {
            let name = uuidv4();
            formData.append("files", file, name);
        }

        return formData;
    }

    selectedImage(blobUrl: string) {
        if (this.blobUrlselected === blobUrl) {
            this.blobUrlselected = "";
        } else {
            this.blobUrlselected = blobUrl;
        }
    }

    downloadPictures(outboundPictures: IOutboundPicture[]) {
        this.$emit("downloadOutboundPictures", outboundPictures);
    }

    deleteSelectedPicture() {
        if (this.blobUrlselected) {
            let indexSource = this.FilteredBlobsSource.findIndex(f => f.blobUrl === this.blobUrlselected);
            let indexDestination = this.FilteredBlobsDestination.findIndex(f => f.blobUrl === this.blobUrlselected);
            let indexOutboundPictures = -1;
            if (indexSource > -1) {
                indexOutboundPictures = this.OutboundPictures.findIndex(i => i.id === this.FilteredBlobsSource[indexSource].id);
            } else {
                if (indexDestination > -1) {
                    indexOutboundPictures = this.OutboundPictures.findIndex(i => i.id === this.FilteredBlobsDestination[indexDestination].id);
                }
            }
            if (indexOutboundPictures === -1) {
                this.$emit("showMessageWarning", "Not found pictures index");
            } else {
                this.$emit("deleteOutboundPicture", this.OutboundPictures[indexOutboundPictures]);
                this.blobUrlselected = "";
            }
        } else {
            this.$emit("showMessageWarning", "Please select a picture to delete");
        }
    }
}
